document.addEventListener('DOMContentLoaded', () => {
  let tabTrigger = document.querySelectorAll('a.trigger');
  if (tabTrigger.length > 0) {
    tabTrigger.forEach( el => {
      el.addEventListener('click', () => {
        document.querySelector('.trigger.tabs__active').classList.remove('tabs__active');
        document.querySelector('.tab-content.tab-content__active').classList.remove('tab-content__active');
        let triggerdata = el.dataset.id;
        let $target = document.getElementById(triggerdata);
        el.classList.toggle('tabs__active');
        $target.classList.toggle('tab-content__active');
      });
    });
  }
  let url = document.location.toString();
  let hash = url.split('#')[1];
  if (hash != undefined) {
    if (tabTrigger.length > 0) {
      tabTrigger.forEach( el => {
        let url = document.location.toString();
        let hash = url.split('#')[1];
        let triggerdata = el.dataset.id;
        if (hash == triggerdata) {
          document.querySelector('.trigger.tabs__active').classList.remove('tabs__active');
          document.querySelector('.tab-content.tab-content__active').classList.remove('tab-content__active');
          let triggerdata = el.dataset.id;
          let $target = document.getElementById(triggerdata);
          el.classList.add('tabs__active');
          $target.classList.toggle('tab-content__active');
        }
      });
    }
  }

});
